import React from "react";
import {
  Link
} from "react-router-dom";

import Notification from 'rc-notification';
import Loading from './../../components/loading.js';
import config from './../config.js';

//import * as echarts from 'echarts';

let notification = null;
Notification.newInstance({
  style: {
    top: '45px',
    right: 0
  }
}, (n) => notification = n);

class Summary extends React.Component {
  constructor(props) {
    super(props);
    let user = {};
    let uistyle = {};
    if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
      user = JSON.parse(localStorage.user);
      if (typeof user.company.type !== 'undefined' && user.company.type !== '') {
        uistyle = JSON.parse(user.company.type);
      }
    }

    this.state = {
      loading: false,
      page_title: '摘要 Summary',
      userid: user.id,
      companyid: user.company_id,
      level: user.level,
      count_user: 0,
      count_project: 0,
      count_file: 0,
      count_article: 0,
      count_service_image: 0,
      count_task_brainlabel: 0,
      count_task_brainlabel_success: 0,
      count_task_pet: 0,
      count_task_pet_success: 0,
      count_service_image_vbm: 0,
      count_service_image_tbss: 0,
      count_service_image_vbm_success: 0,
      count_service_image_tbss_success: 0,
      count_subjects_company: 0,
      projects: [],
      file_size: 0,
      files: [],
      service_image: [],
      task_brainlabel: [],
      task_pet: [],
      users: [],
      articles: [],
      uistyle: uistyle,
      subjects: [],
      count_subjects: 0,
      list_subjects: []
    };

    document.title = this.state.page_title;
    //this.resize.bind(this);
  }


  componentDidMount() {
    this.getSummary();
    //window.addEventListener('resize', this.resize);
  }

  componentWillUnmount() {
    //window.removeEventListener('resize', this.resize);
  }

  getSummary() {
    const me = this;
    const {
      level,
      companyid,
      userid
    } = me.state;
    const postdata = {
      level: level,
      companyid: companyid,
      userid: userid,
      request: 'summary',
      Authorization: localStorage.token
    };
    me.setState({
      loading: true
    });
    fetch(config.host + '/summary/index', {
      method: 'post',
      body: JSON.stringify(postdata)
    })
      .then(res => res.json())
      .then(json => {
        if (json.status === 1) {
          const data = json.data;
          //console.log(data);
          let subjects = data.subjects;
          if (subjects != false) {
            data.list_subjects = subjects.result;
            data.count_subjects = subjects.total;
          }
          me.setState(Object.assign({}, data));

          //me.setEcharts();
        } else if (json.status === 0 && json.action === 'logout') {
          me.setState({
            loading: false
          });

          me.notify(json.message);
          localStorage.token = '';
          setTimeout(() => {
            me.props.history.push('/');
          }, 2000)


        }


        me.setState({
          loading: false
        });
      })
      .catch(function (error) {
        console.log(error);
        me.setState({
          loading: false
        });
      });
  }



  approx(bytevalue) { //计算文件单位和大小
    let filebtout = '';
    for (let units = ["KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], n = 0, Approx = bytevalue / 1024; Approx > 1; Approx /= 1024, n++) {
      filebtout = Approx.toFixed(3) + " " + units[n];
    }
    return filebtout;
  }

  notify(message) {
    notification.notice({
      content: <span>{message}</span>,
      duration: 4,
      style: {
        'bottom': 0,
        'right': 0
      }
    });
  }

  render() {
    let {
      file_size,
      uistyle,
      list_subjects,
      count_subjects,
      count_subjects_company
    } = this.state;

    file_size = this.approx(file_size);
    let pathurl = this.props.location.pathname;
    let tbody = '';
    if (this.state.projects.length) {
      tbody = this.state.projects.map((item, index) => {
        let encriptedsize = item.encriptedsize === '' ? '0' : this.approx(item.encriptedsize);
        return (<tr key={index}>
          <td> <Link className="" to={`/console/myprojects/project/${item.id}/0`}> {item.name} </Link> </td>
          <td><small className="text-muted">{item.user} </small></td>
          <td><small className="text-muted" title="最近更新">{item.update_time}</small></td>
          <td>{item.allsubjects}</td>
          <td>{item.allfiles}</td>
        </tr>)
      });
    }


    return (

      <div>
        <Loading display={this.state.loading} />
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 ">
          <h3>{this.state.page_title}</h3>
        </div>

        <div className="card shadow mb-3 ">
          <div className="card-body">
            <h5 className="card-title">受试者 <small className="float-right"><Link className="badge badge-pill badge-success" to={`/console/list_subjects/0/0`}>  {count_subjects} 例 </Link></small></h5>
            <table className="table">
              <thead>
                <tr>
                  <th>名称</th>
                  <th>性别</th>
                  <th>年龄</th>

                  {uistyle.is_subjectuid && <th>UID</th>}
                  <th>创建时间</th>
                </tr>
              </thead>
              <tbody>
                {list_subjects.length > 0 && list_subjects.map((subject, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        <Link className="" to={`/console/subject_files/0/${subject.id}/0/?to=${pathurl}`}> {subject.subject_name}</Link>
                      </td>
                      <td>{subject.subject_gender === 0 || subject.subject_gender === '0' ? '男' : '女'}</td>
                      <td>{subject.subject_age}</td>
                      {uistyle.is_subjectuid && <td>{subject.subject_uid || ''}</td>}
                      <td>{subject.date_created}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>

        {uistyle.is_project &&
          <div className="card shadow mb-3 ">
            <div className="card-body">
              <h5 className="card-title">项目 <small className="float-right"><Link className="badge badge-pill badge-success" to={`/console/myprojects`}>{this.state.count_project}</Link></small></h5>
              <table className="table">
                <thead>
                  <tr>
                    <th>项目名称</th>
                    <th>创建人</th>
                    <th>更新时间</th>
                    <th>受试者</th>
                    <th>序列</th>
                  </tr>
                </thead>
                <tbody>
                  {tbody}
                </tbody>
              </table>
            </div>
          </div>
        }
        <div className="card-group pd-3 mb-3 shadow">
          {(uistyle.is_vbm || uistyle.is_tbss) &&
            <div className="card ">
              <div className="card-body">
                <h5 className="card-title">VBM/TBSS任务 <small className="float-right"> <span className="badge badge-pill badge-success">VBM:{this.state.count_service_image_vbm}  </span> <span className="badge badge-pill badge-success">TBSS:{this.state.count_service_image_tbss} </span> </small></h5>
                <div className="list-group list-group-flush">
                  {
                    this.state.service_image.length && this.state.service_image.map((item, index) => {
                      return (
                        <Link className="list-group-item  list-group-item-action d-flex justify-content-between" key={index} to={`/console/myprojects/project/service_list/${item.project_id}/${item.type}`}>
                          <span>
                            {item.task_name} <br />
                            <i className="fa fa-clock text-muted" > </i> <small className="text-muted">{item.date_created}</small>
                          </span>
                          <span>

                            {(() => {
                              switch (item.status) {
                                case '0':
                                  return (<small className="badge badge-primary">等待处理</small>);

                                case '1':
                                  return (<small className="badge badge-info">处理完成</small>);

                                case '2':
                                  return (<small className="badge badge-danger">处理失败</small>);

                                case '3':
                                  return (<small className="badge badge-primary">暂停处理</small>);

                                case '4':
                                  return (<small className="badge badge-warning">正在处理</small>);

                                default:
                                  break;
                              }
                            })()}
                          </span>
                        </Link>
                      );
                    })
                  }

                </div>
              </div>
            </div>
          }

          {uistyle.is_pet &&
            <div className="card ">
              <div className="card-body">
                <h5 className="card-title">PET分析 <small className="float-right"><span className="badge badge-pill badge-success">{this.state.count_task_pet}次任务</span> </small></h5>
                <div className="list-group list-group-flush">
                  {
                    this.state.task_pet.length && this.state.task_pet.map((item, index) => {

                      return (
                        <Link className="list-group-item  list-group-item-action d-flex justify-content-between" key={index} to={`/console/list_service/${item.project_id || 0}/pet`} projectid={item.project_id}>
                          <span>
                            {item.subject_number} {item.subject_age}岁 {item.subject_gender === '1' ? '女' : '男'}
                            <br /><i className="fa fa-clock text-muted"></i> <small className="text-muted">{item.date_update}</small>
                          </span>
                          <span>
                            {(() => {
                              switch (item.status) {
                                case '0':
                                  return (<small className="badge badge-primary">正在解析</small>);
                                case '1':
                                  return (<small className="badge badge-warning">处理中</small>);
                                case '2':
                                  return (<small className="badge badge-info">已完成</small>);
                                case '3':
                                  return (<small className="badge badge-danger">处理失败</small>);
                                default:
                                  break;
                              }
                            })()
                            }
                          </span>
                        </Link>
                      );
                    })
                  }
                </div>
              </div>
            </div>
          }
          <div className="card ">
            <div className="card-body">
              <h5 className="card-title">全脑分割任务 <small className="float-right"><Link className="badge badge-pill badge-success" to={`/console/list_service/0/brainlabel`}>{this.state.count_task_brainlabel}次任务</Link> </small></h5>
              <div className="list-group list-group-flush">
                {
                  this.state.task_brainlabel.length && this.state.task_brainlabel.map((item, index) => {

                    return (
                      <Link className="list-group-item  list-group-item-action d-flex justify-content-between" key={index} to={`console/list_service/${item.project_id}/brainlabel`} projectid={item.project_id}>
                        <span>
                          {item.subject_number} {item.subject_age}岁 {item.subject_gender === '1' ? '女' : '男'}
                          <br /><i className="fa fa-clock text-muted"></i> <small className="text-muted">{item.date_update}</small>
                        </span>
                        <span>
                          {(() => {
                            switch (item.status) {
                              case '0':
                                return (<small className="badge badge-primary">正在解析</small>);
                              case '1':
                                return (<small className="badge badge-warning">处理中</small>);
                              case '2':
                                return (<small className="badge badge-info">已完成</small>);
                              case '3':
                                return (<small className="badge badge-danger">处理失败</small>);
                              default:
                                break;
                            }
                          })()
                          }
                        </span>
                      </Link>
                    );
                  })
                }
              </div>
            </div>
          </div>
        </div>

        {
          this.state.level < 2 &&
          <div className="card-group pd-3 mb-5">
            <div className="card shadow animated slideInDown">
              <div className="card-body">
                <h5 className="card-title">用户 <small className="float-right"><Link className="badge badge-pill badge-success" to={`/console/manager/list_user`}>{this.state.count_user}</Link> </small></h5>
                <ul className="list-group list-group-flush">
                  {
                    this.state.users.length && this.state.users.map((item, index) => {
                      return (
                        <li className="list-group-item  list-group-item-action" key={index}>
                          {item.realname} <small className="text-muted">{item.address} {item.email}</small>
                          <div><i className="fa fa-clock text-muted"></i> <small className="text-muted">{item.date_login}</small></div>
                        </li>
                      );
                    })
                  }
                </ul>
              </div>
            </div>

            <div className="card shadow animated slideInDown">
              <div className="card-body">
                <h5 className="card-title">文件 <small className="float-right"><span className="badge badge-pill badge-success">{this.state.count_file}件</span> <span className="badge badge-pill badge-success">{file_size}</span> </small></h5>
                <ul className="list-group list-group-flush">
                  {
                    this.state.files.length && this.state.files.map((item, index) => {
                      return (
                        <li className="list-group-item  list-group-item-action" key={index}>
                          <span className="d-inline-block ">{item.file_name} </span>
                          <div><i className="fa fa-clock text-muted"></i> <small className="text-muted text-nowrap">{item.date_created}</small></div>
                        </li>
                      );
                    })
                  }
                </ul>
              </div>
            </div>

          </div>
        }
      </div>


    );
  }
}

export default Summary


// WEBPACK FOOTER //
// ./src/apps/console/summary.js